import { getPersonalLineupQueryData } from './queries';

export function getPersonalLineup() {
  const queryData = getPersonalLineupQueryData();

  if (queryData && queryData.allLineups.length) {
    return queryData;
  }
}
